export default function (path, cb, args, charset, timeout) {
  var _head = document.getElementsByTagName("head")[0], _js = document.createElement("script"), timeoutHandler = null, _eventHandlerLoad = function () {
    _cancelScript();
    typeof cb == "function" && cb(args, true);
  }, _eventHandlerError = function () {
    _cancelScript();
    typeof cb == "function" && cb(args, false);
  }, _cancelScript = function () {
    if (!_js) {
      return;
    }
    try {
      _js.src = "";
    } catch (_) {
    }
    _js.removeEventListener("load", _eventHandlerLoad);
    _js.removeEventListener("error", _eventHandlerError);
    _head.removeChild(_js);
    _js = null;
    if (timeoutHandler) {
      clearTimeout(timeoutHandler);
      timeoutHandler = null;
    }
  };
  _js.addEventListener("load", _eventHandlerLoad);
  _js.addEventListener("error", _eventHandlerError);
  _js.charset = charset || "utf-8";
  _js.src = path;
  _head.insertBefore(_js, _head.firstChild);
  if (timeout) {
    timeoutHandler = setTimeout(() => {
      _cancelScript();
      typeof cb == "function" && cb(args, null);
    }, timeout);
  }
}
